<template>
  <div class="start">
    <div class="title">
      <img
        class="title-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b782fd544cfc0779785d63730cd9a04d.png"
        alt=""
      />
    </div>
    <div class="banner">
      <div class="image"></div>
      <img
        class="cup"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/drink_water_reminder_cup"
        alt=""
      />
    </div>
    <div class="btn-container">
      <div class="has" @click="bindCode">我已有彩虹杯，去扫码绑定</div>
      <div class="not" @click="bindGetCup">
        我没有彩虹杯，去拥有Ta<span class="iconfont icon-you"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {
    bindGetCup() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/wmOtherPage?fromType=11&url=https://100001525455.retail.n.weimob.com/saas/retail/100001525455/2494001455/goods/detail?id=1426923850155'
        )
      }
    },
    bindRes(url) {
      if (url == location.origin + '/drink-water-reminder/register') {
        this.registerWaterUser()
      } else {
        this.$toast('识别的二维码不能跳转')
      }
    },
    registerWaterUser() {
      this.$http
        .postBaseApp('member/WaterClock/registerWaterUserForApp', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$router.replace({
              path: '/drink-water-reminder/fill',
              query: this.$route.query
            })
          } else {
            this.$toast(res.msg)
          }
        })
    },
    async bindCode() {
      if (this.$betterwe.isApp()) {
        let res = await this.$betterwe.onAppScanQRCode().catch(() => {})
        if (res) {
          if (res.code == 0) {
            if (res.path) {
              this.bindRes(res.path)
            } else {
              this.$toast('扫码失败')
            }
          } else {
            this.$toast('未打开相机权限')
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.start {
  width: 100%;
  height: 100vh;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/110c430ebad17f03af06e7418907c420.png');
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  .title {
    width: 100%;
    margin-top: 80px;
    height: 87px;
    margin-bottom: 25px;
    .title-image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .banner {
    text-align: center;
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;
    .image {
      position: absolute;
      width: 100%;
      left: 0;
      height: 100%;
      bottom: 0;
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/44dbb134b4d0777cc79822ea413633df.png');
      background-repeat: no-repeat;
      background-position: center bottom;
      background-size: contain;
    }
    .cup {
      position: absolute;
      left: 50%;
      top: 0%;
      transform: translate(-50%, 0%);
      z-index: 10;
      height: 81%;
      object-fit: contain;
    }
  }
}
.btn-container {
  width: 283px;
  text-align: center;
  margin-bottom: 7.1vh;
  .has {
    height: 42px;
    line-height: 42px;
    background: #6236ff;
    border-radius: 12px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 12px;
  }
  .not {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #6236ff;
    line-height: 20px;
    .iconfont {
      margin-left: 6px;
    }
  }
}
</style>
